export default class Menu{   

    Id;
    IdPadre;
    TipoMenu;
    TipoElemento;
    Lingua;
    Etichetta;
    Permalink;
    Posizione;
    LinkEsterno;
    UrlManuale;


    constructor(){               
    }
}